@if (isLoading) {
  <div class="order-placed-container" [class.flow-layout]="useFlowLayout">
    <div
      class="order-placed-container-inner"
      [class.flow-layout]="useFlowLayout"
      style="text-align: center"
    >
      <crowdctrl-loading-card message="Loading order..."></crowdctrl-loading-card>
    </div>
  </div>
} @else if (errorMessage) {
  <div class="order-placed-container" [class.flow-layout]="useFlowLayout">
    <div
      class="order-placed-container-inner"
      [class.flow-layout]="useFlowLayout"
      style="text-align: center"
    >
      <p style="color: var(--ion-color-danger)">{{ errorMessage }}</p>
      @if (showDismissButton) {
        <crowdctrl-loading-button
          expand="block"
          size="large"
          class="ok-button"
          [loading]="isDismissNavigating"
          style="margin-top: 2rem"
          (pressed)="onDismissClick()"
        >
          {{ dismissButtonText }}
        </crowdctrl-loading-button>
      }
    </div>
  </div>
} @else if (order) {
  <div class="order-placed-container" [class.flow-layout]="useFlowLayout">
    <div class="order-placed-container-inner" [class.flow-layout]="useFlowLayout">
      <div class="icon-container">
        <ion-icon name="checkmark-circle" class="success-icon"></ion-icon>
      </div>
      <h1 class="title">Order Placed</h1>
      <p class="message">Your order has been successfully placed.</p>

      <p class="order-number-label">Order #</p>
      <p class="order-number">
        {{ order.sessionSequence != null ? order.sessionSequence : '—' }}
      </p>
      @if (!compact && !hideExtendedOrderDetails) {
        <div class="order-meta">
          <p class="meta-line">
            Workspace Order #
            {{ order.workspaceSequence != null ? order.workspaceSequence : '—' }}
          </p>
          <p class="meta-line">
            Session Order #
            {{ order.sessionSequence != null ? order.sessionSequence : '—' }}
          </p>
          <p class="meta-line">
            Queue Order #
            {{ order.queueSequence != null ? order.queueSequence : '—' }}
          </p>
        </div>
        @if (order.id) {
          <p class="order-id-line">Order ID {{ order.id }}</p>
        }

        <hr class="divider" />

        <ion-grid class="order-details-grid">
          @if (order.queueName) {
            <ion-row
              ><ion-col size="5" class="detail-label-col">Queue</ion-col
              ><ion-col class="detail-value-col">{{ order.queueName }}</ion-col></ion-row
            >
          } @else if (order.queueId) {
            <ion-row
              ><ion-col size="5" class="detail-label-col">Queue</ion-col
              ><ion-col class="detail-value-col">{{ order.queueId }}</ion-col></ion-row
            >
          }
          @if (customerIdentifier) {
            <ion-row
              ><ion-col size="5" class="detail-label-col">{{
                isNumericId ? 'Customer ID' : 'Customer name'
              }}</ion-col
              ><ion-col class="detail-value-col">{{ customerIdentifier }}</ion-col></ion-row
            >
          }
          @if (order.createdAt) {
            <ion-row
              ><ion-col size="5" class="detail-label-col">Created at</ion-col
              ><ion-col class="detail-value-col">{{
                order.createdAt | crowdctrlFormatDate
              }}</ion-col></ion-row
            >
          }
        </ion-grid>
      }
      <div class="action-buttons">
        @if (orderTicketPrintService.showAndroidPrintTicketButton()) {
          <ion-button
            expand="block"
            size="large"
            (click)="onPrintClick()"
            class="action-button"
            [disabled]="isPrinting"
          >
            <ion-icon name="print-outline" slot="start"></ion-icon>
            {{ isPrinting ? 'Printing…' : 'Print ticket' }}
            @if (isPrinting) {
              <ion-spinner name="crescent" slot="end"></ion-spinner>
            }
          </ion-button>
        }
        @if (showDismissButton) {
          <crowdctrl-loading-button
            expand="block"
            size="large"
            fill="outline"
            class="action-button"
            endIcon="chevron-forward"
            [loading]="isDismissNavigating"
            (pressed)="onDismissClick()"
          >
            {{ dismissButtonText }}
          </crowdctrl-loading-button>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="order-placed-container" [class.flow-layout]="useFlowLayout">
    <div
      class="order-placed-container-inner"
      [class.flow-layout]="useFlowLayout"
      style="text-align: center"
    >
      <p>No order information available.</p>
      @if (showDismissButton) {
        <crowdctrl-loading-button
          expand="block"
          size="large"
          class="ok-button"
          [loading]="isDismissNavigating"
          style="margin-top: 2rem"
          (pressed)="onDismissClick()"
        >
          {{ dismissButtonText }}
        </crowdctrl-loading-button>
      }
    </div>
  </div>
}
